import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20theater%20auditorium%20with%20soft%20golden%20stage%20lighting%2C%20empty%20red%20velvet%20seats%20in%20rows%2C%20rich%20dark%20wood%20paneling%20on%20walls%2C%20elegant%20cinema%20interior%20with%20warm%20ambient%20glow%2C%20atmospheric%20depth%20and%20dramatic%20lighting%20composition&width=1800&height=700&seq=cta-bg-01&orientation=landscape"
        alt="加入我们的影视推荐社区"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white font-heading mb-4">
          找不到想看的？告诉我们
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
          如果你有特别想看的影片类型或需要更精准的推荐，欢迎给我们留言。我们的团队会尽快为你提供最合适的看片网站推荐。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            联系我们
          </Link>
          <Link
            to="/category/latest-movies"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 text-white backdrop-blur-sm rounded-full font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20"
          >
            浏览全部推荐
          </Link>
        </div>
      </div>
    </section>
  );
}